import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAutomationTemplateStepOpportunityUpdateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IOpportunityAutomationStep) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			templateId,
			stepId,
			step,
			impersonationContext,
		}: {
			templateId: string;
			stepId: string;
			step: Api.IOpportunityAutomationStep;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/Step/Opportunity/${encodeURIComponent(
						stepId
					)}`,
					impersonationContext,
				}),
				'PUT',
				step
			);
		},
		onError,
		onSuccess,
	});
}
